import { type I18n } from '@lingui/core'

import ReavailabilityService from 'shared/services/api/ReavailabilityService'
import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'

import BuyBoxSendEmailFormContainer from '.'

type Props = {
  container: HTMLElement | null
  i18n: I18n
  api: { reavailabilityService: ReavailabilityService }
}

export default async ({ container, i18n }: Props) => {
  await hydrateWithHOCs({
    container,
    i18n,
  })(<BuyBoxSendEmailFormContainer />)
}
